exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0b85198f] .van-tabs--card>.van-tabs__wrap{height:36px;font-size:.875rem}[data-v-0b85198f] .van-tabs__nav{height:32px}[data-v-0b85198f] .van-tabs__content{height:calc(100% - 30px)}[data-v-0b85198f] .van-tab{font-size:12px}[data-v-0b85198f] .van-tabs__nav--card .van-tab.van-tab--active{background-color:#c52a1a;color:#fff}[data-v-0b85198f] .van-tabs__nav--card .van-tab{color:#7d7d7d}[data-v-0b85198f] .van-tabs__nav--card{border-color:#979797}[data-v-0b85198f] .van-tab__pane{height:100%}[data-v-0b85198f] .van-tabs__nav--card .van-tab{border-right:1px solid #c52a1a}[data-v-0b85198f] .van-tabs__nav--card .van-tab:last-child{border-right:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b85198f","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/search/SearchRelationshipList.vue
// module id = 884
// module chunks = 0